import { TaskListItem } from '@myapp/contract'
import { Clock, ChevronRight } from 'lucide-react'

interface Props {
  tasks: TaskListItem[]
  onTaskClick: (taskId: number) => void
}

function formatDeadline(iso: string): string {
  const d = new Date(iso)
  return d.toLocaleDateString('de-DE', { day: '2-digit', month: '2-digit', year: 'numeric' })
}

export const UnscheduledTasksBanner = ({ tasks, onTaskClick }: Props) => {
  if (tasks.length === 0) return null

  return (
    <div className="flex flex-col gap-1.5 px-3 py-2 bg-red-50/50 border-b border-red-100">
      <span className="text-[11px] font-medium text-red-400 uppercase tracking-wide">
        Offene Aufgaben
      </span>
      {tasks.map((task) => (
        <div
          key={task.id}
          className="flex items-center gap-2.5 bg-white rounded-lg shadow-sm border border-red-200 border-l-4 px-3 py-2 cursor-pointer hover:shadow-md hover:-translate-y-0.5 transition-all duration-200 select-none"
          style={{ borderLeftColor: '#D96868' }}
          onClick={() => onTaskClick(task.id)}
        >
          <Clock size={15} color="#D96868" className="shrink-0" />
          <div className="flex-1 min-w-0">
            <p className="text-sm font-semibold text-gray-800 truncate leading-tight">
              {task.title}
            </p>
            {task.deadline && (
              <p className="text-xs text-gray-500 leading-tight mt-0.5">
                bis {formatDeadline(task.deadline)}
              </p>
            )}
          </div>
          <ChevronRight size={15} className="shrink-0 text-gray-400" />
        </div>
      ))}
    </div>
  )
}
